import ErrorBoundary from 'components/error/ErrorBoundary';
import ContentLayout from 'components/layouts/Default/ContentLayout';
import ScrollTopOnChange from 'components/ScrollTopOnChange';
import PageViewTracker from 'components/PageViewTracker';
import RecentAppsTracker from 'modules/recentApps/RecentAppsTracker';
import NavigationProvider from 'modules/navigation/NavigationProvider';
import GlobalShortCuts from 'modules/shortcuts';
import React, {useRef} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {nest, withProps} from 'recompose';
import NoFoundPage from 'views/NoFoundPage';
import LoadMeta from '../meta/LoadMeta';
import RouteWithSubRoutes from './RouteWithSubRoutes';
import {compose} from "redux";


export const RedirectToModal = compose(
    withProps(
        props => ({
            to: {
                ...props.location,
                state: {
                    isModal: true
                }
            }
        })
    )
)(Redirect)

export const createRoutes = ({modalRoutesConfig = [], routesConfig = []}) => {
    const modalRoutes = modalRoutesConfig.map(
        (route, i) => (
            <RouteWithSubRoutes
                key={i}
                {...route} />
        )
    );
    const redirectModalRoutes = modalRoutesConfig.map(
        (route, i) => (
            <Route
                key={i}
                {...route}
                component={RedirectToModal}
            />
        )
    );
    const mainRoutes = [
        ...redirectModalRoutes,
        ...routesConfig.map((route, i) => (
            <RouteWithSubRoutes
                key={i}
                {...route} />
        )),
        <Route
            key="page_not_found"
            path="/"
            withSubDomain={true}
            render={nest(
                ContentLayout,
                NoFoundPage
            )}/>
    ];
    const Routes = ({
                        match,
                        location,
                        history
                    }) => {
        const isModal = !!(
            location.state &&
            location.state.isModal
        );
        const saveLocationRef = useRef(
            location
        );

        if (!isModal) {
            saveLocationRef.current = location;
        }

        const mainLocation = isModal
            ? saveLocationRef.current
            : location;
        return (
            <ErrorBoundary>
                <NavigationProvider
                    {...{
                        match,
                        history,
                        location,
                        isModal,
                        mainLocation,
                        saveLocation: saveLocationRef.current,
                        routesConfig,
                        modalRoutesConfig
                    }}>
                    <ErrorBoundary>
                        <LoadMeta/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <GlobalShortCuts/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <ScrollTopOnChange
                            value={mainLocation.pathname}/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <PageViewTracker
                            value={mainLocation.pathname}/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <RecentAppsTracker
                            value={mainLocation.pathname}/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <Switch
                            location={mainLocation}>
                            {mainRoutes}
                        </Switch>
                    </ErrorBoundary>
                    {isModal && (
                        <ErrorBoundary>
                            <Switch location={location}>
                                {modalRoutes}
                            </Switch>
                        </ErrorBoundary>
                    )}
                </NavigationProvider>
            </ErrorBoundary>
        );
    };
    return Routes;
};
